import actionsAndConstants from '../shared/actionsAndConstants';

const { app: { actions: appActions } } = actionsAndConstants;

const alerts = action$ =>
  action$.filter(({ meta }) => meta && meta.alert && meta.alert.message)
    .map(({ meta: { alert } } = {}) => appActions.showAlert(alert));

export default alerts;



// WEBPACK FOOTER //
// ./src/epics/alerts.js